import React from "react";
import { Link } from "react-router-dom";

import { Button, type ButtonSize, type ButtonVariant } from "./base/button";

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Squares the link for a lone icon; give it an `aria-label`. */
  iconOnly?: boolean;
}

/**
 * A link that looks exactly like a Button — same levels, sizes and states — for
 * navigation among actions. `href` resolves like a router link, so a relative
 * "add" points at the same URL on click and when opened in a new tab, and an
 * absolute URL (an API download) is left as it is.
 */
export function AButton({
  href,
  className,
  variant = "secondary",
  size = "md",
  iconOnly,
  children,
  ...rest
}: Props) {
  return (
    <Button
      asChild
      variant={variant}
      size={size}
      iconOnly={iconOnly}
      className={className}
    >
      <Link {...rest} to={href}>
        {children}
      </Link>
    </Button>
  );
}
